import Layout from '../../views/layout/index.vue';

const cctv = {
  path: '/cctv-management',
  name: 'cctvmanagement',
  meta: {
    title: 'CCTV Management',
    icon: 'Inbound',
  },
  component: () => import('@/views/layout/index.vue'),
  children: [
    {
      path: '/cctv/video',
      name: 'cctvmanagement.video',
      meta: {
        title: 'Video View',
      },
      redirect: '/cctv-management/video',
    },
    {
      path: '/cctv/photo',
      name: 'cctvmanagement.photo',
      meta: {
        title: 'Photo View',
      },
      redirect: '/cctv-management/photo',
    },
    {
      path: '/cctv/device',
      name: 'cctvmanagement.device',
      meta: {
        title: 'Device',
      },
      redirect: '/cctv-management/device',
    },
    {
      path: '/cctv/station-device-mapping',
      name: 'cctvmanagement.devicemapping',
      meta: {
        title: 'Station & Device Mapping',
      },
      redirect: '/cctv-management/station-device-mapping',
    },
    {
      path: '/cctv/query-tool',
      name: 'cctvmanagement.orderquery',
      meta: {
        title: 'Video/Photo Query Tool',
      },
      redirect: '/cctv-management/query-tool',
    },
    {
      path: '/cctv/event-center',
      name: 'cctvmanagement.event',
      meta: {
        title: 'Event Center',
      },
      redirect: '/cctv-management/event-center',
    },
    {
      path: '/cctv/access-control',
      name: 'cctvmanagement.accesscontrol',
      meta: {
        title: 'CCTV Access Control',
      },
      redirect: '/cctv-management/access-control',
    },
  ],
};

export default cctv;
